import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { loginUserStart } from '../../../../redux/user/user.actions';
import { useForm } from '../../../../hooks';
import validateLogin from './validateLogin';
import './styles.scss';
import useTranslation from 'hooks/useTranslation';

const LoginForm = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation('AUTH');
  const { t } = getTranslation();

  const handleLogin = (values) => {
    dispatch(loginUserStart({ userCredentials: values, history }));
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    validateLogin,
    handleLogin,
    { email: '', password: '' }
  );

  const renderLoginButton = (
    <div className='form_control flex button'>
      <input
        type='submit'
        value={t('LOGIN_FORM_SUBMIT')}
        className='btn btn-primary'
      />
    </div>
  );

  return (
    <form className='form' id='login_form' onSubmit={handleSubmit} noValidate>
      <div className='form_control flex'>
        <input
          type='email'
          name='email'
          className={clsx(errors.email && 'has-error')}
          value={values.email}
          onChange={handleChange}
          placeholder={t('EMAIL_PLACEHOLDER')}
          id='email'
          autoFocus
        />
        {errors.email && <div className='error'>{errors.email}</div>}
      </div>
      <div className='form_control flex'>
        <input
          type='password'
          name='password'
          id='password'
          className={clsx(errors.password && 'has-error')}
          value={values.password}
          onChange={handleChange}
          placeholder={t('PASSWORD_PLACEHOLDER')}
        />
        {errors.password && <div className='error'>{errors.password}</div>}
      </div>
      {renderLoginButton}
    </form>
  );
};

export default LoginForm;
